import { Form } from '@/core/components/form/form'
import { TextField } from '@/core/components/form/text-field'
import { Button } from '@/core/components/form/button'
import { fetch } from '@/core/utils/drf/fetch'
import { doc } from './doc'
import { useTranslation } from 'react-i18next'

export const ConfirmEmailForm = doc(({ onSuccess }) => {
  const { t } = useTranslation()
  const form = {
    name: 'confirmationEmail',
    validations: {},
    onSubmit: (data) => {
      return fetch('requestConfirmEmail', { method: 'POST', body: data })
        .then((res) => {
          onSuccess?.()
        })
        .catch((err) => {
          throw err
        })
    },
  }
  return (
    <Form {...form}>
      <TextField
        name="email"
        placeholder={t('auth.confirmEmailForm.email.placeholder')}
        type="email"
      />
      <Button>{t('auth.confirmEmailForm.button')}</Button>
    </Form>
  )
})
